export const DASHBOARD = '/dashboard'
export const LOGIN = '/login'
export const SIGN_UP = '/signup'
export const PROFILE = '/profile'
export const FORGOT_PASSWORD = '/forgot-password'
export const SEARCH = '/search'
export const RECOMMENDED = '/recommended-for-you'
export const INBOX = '/inbox'
export const BLOG = '/blog'
export const LIKES = '/likes'
export const FOLLOWING = '/following'
export const CREATE_POST = '/create-post'
export const NOT_FOUND = '/not-found'